var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-transition-stack',{class:[
		_vm.$s.FullScreenFixed,
		( _obj = {}, _obj[_vm.$s.ActionbarOffset] = _vm.addActionbarOffset, _obj )
	],attrs:{"before-enter-class":_vm.$s.fade_bottom}},_vm._l((_vm.toastApi.state.toasts),function(toast){return _c('toast-render-fn',{key:toast.key,attrs:{"render-fn":toast.renderFn}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }